import { render, staticRenderFns } from "./StatisticCardWithAreaChart.vue?vue&type=template&id=29024d9f&scoped=true&"
import script from "./StatisticCardWithAreaChart.vue?vue&type=script&lang=js&"
export * from "./StatisticCardWithAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardWithAreaChart.vue?vue&type=style&index=0&id=29024d9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29024d9f",
  null
  
)

export default component.exports